import api from '@/api'
import Vue from 'vue'

const Q = require('q')
const { HTTP_STATUS } = require('@/helpers/constants')

const state = {
  simulaciones: [],
  simulacionesWind: [],
  activeSimulacion: null,
  cerrarSimulacionSlider: false
}

const getters = {
  simulaciones: (state) => state.simulaciones,
  simulacionesWind: (state) => state.simulacionesWind,
  getSimulacionByIncendioID: (state) => (idIncendio) => {
    return state.simulaciones.filter(x => x.ID_INCENDIO === idIncendio)
  },
  activeSimulacion: state => state.activeSimulacion,
  cerrarSimulacionSlider: state => state.cerrarSimulacionSlider
}

const mutations = {
  SET_SIMULACIONES (state, simulaciones) {
    state.simulaciones = simulaciones
  },

  SET_SIMULACIONES_WIND (state, simulacionesWind) {
    state.simulacionesWind = simulacionesWind
  },

  ADD_SIMULACION (state, simulacion) {
    state.simulaciones.push(simulacion)
  },

  UPDATE_SIMULACION (state, simulacion) {
    const index = state.simulaciones.findIndex(item => item.ID_SIMULACION === simulacion.ID_SIMULACION)
    if (index !== -1) {
      state.simulaciones[index] = simulacion
    }
  },

  DELETE_SIMULACION (state, simulacion) {
    state.simulaciones.splice(state.simulaciones.indexOf((a) => a.ID_SIMULACION === simulacion.ID_SIMULACION))
  },

  SET_ACTIVE_SIMULACION (state, simulacion) {
    state.activeSimulacion = simulacion
  },

  SET_CERRAR_SIMULACION_SLIDER (state, value) {
    state.cerrarSimulacionSlider = value
  },

  SOCKET_SET_SIMULACION_ESTADO_BY_ID (state, data) {
    const idSimulacion = data.idSimulacion
    const estado = data.estado
    const index = state.simulaciones.findIndex(item => item.ID_SIMULACION.equalsIgnoreCase(idSimulacion))
    const indexViento = state.simulacionesWind.findIndex(item => item.ID_SIMULACION.equalsIgnoreCase(idSimulacion))

    if (index !== -1) {
      const simulacionActualizada = {
        ...state.simulaciones[index],
        ESTADO: estado
      }

      Vue.set(state.simulaciones, index, simulacionActualizada)
    }

    if (indexViento !== -1) {
      const simulacionActualizada = {
        ...state.simulacionesWind[indexViento],
        ESTADO: estado
      }

      Vue.set(state.simulacionesWind, indexViento, simulacionActualizada)
    }
  }
}

const actions = {
  async fetchSimulaciones ({ commit }, data) {
    const deferred = Q.defer()

    try {
      const response = await api.simulacion.getSimulaciones(data)
      const todasLasSimulaciones = response.data

      const simulacionesIncendio = todasLasSimulaciones.filter(s => s.TIPO === 'INCENDIO')
      const simulacionesViento = todasLasSimulaciones.filter(s => s.TIPO === 'VIENTO')

      commit('SET_SIMULACIONES', simulacionesIncendio)
      commit('SET_SIMULACIONES_WIND', simulacionesViento)

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },

  async addSimulacion ({ commit }, data) {
    const deferred = Q.defer()

    const datosSimulador = data.datosSimulador
    const datosBackend = data.datosBackend

    try {
      let responseSimulador = null
      const callbackUrl = await api.simulacion.generateCallback()
      datosSimulador.simulationReportStatusURL = callbackUrl.data

      if (data.tipo === 'INCENDIO') {
        responseSimulador = await api.simulacion.simulate(datosSimulador) // Crear simulacion en server simulacion
      } else {
        responseSimulador = await api.simulacion.simulateWind(datosSimulador) // Crear simulacion de vientos en server simulacion
      }

      if (responseSimulador.status === HTTP_STATUS.ACCEPTED) {
        datosBackend.ID_SIMULACION = responseSimulador.data
        datosBackend.TIPO = data.tipo
        datosBackend.ESTADO = 'NEW'
        const responseBackend = await api.simulacion.addSimulacion(datosBackend) // Insertar simulacion en BBDD backend

        if (responseBackend.status === HTTP_STATUS.OK) {
          const responseEstado = await api.simulacion.setStatusSimulationRepo(responseSimulador.data, 'NEW')

          if (responseEstado.status === HTTP_STATUS.OK) {
            const nuevaSimulacion = {
              ...responseBackend.data,
              ESTADO: 'NEW'
            }
            commit('ADD_SIMULACION', nuevaSimulacion)

            deferred.resolve()
          } else {
            deferred.reject(responseEstado)
          }
        } else {
          deferred.reject(responseBackend)
        }
      } else {
        deferred.reject(responseSimulador)
      }
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  },

  async updateSimulacion ({ commit }, data) {
    const deferred = Q.defer()
    try {
      const response = await api.simulacion.updateSimulacion(data)
      if (response.status === HTTP_STATUS.OK) {
        const updatedSim = response.data

        const nuevasSimulaciones = state.simulaciones.map(sim =>
          sim.ID_SIMULACION === updatedSim.ID_SIMULACION ? updatedSim : sim
        )

        commit('SET_SIMULACIONES', nuevasSimulaciones)
        deferred.resolve()
      } else {
        deferred.reject('Error al actualizar la simulación')
      }
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }
    return deferred.promise
  },

  async deleteSimulacion ({ commit }, simulacion) {
    try {
      const response = await api.simulacion.deleteSimulacionBDD(simulacion.ID_SIMULACION)

      if (response.status === HTTP_STATUS.OK) {
        commit('DELETE_SIMULACION', simulacion)
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  communicateSimulacion ({ commit }, simulacion) {
    commit('SET_ACTIVE_SIMULACION', simulacion)
  },

  cerrarSimulacionSlider ({ commit }, value) {
    commit('SET_CERRAR_SIMULACION_SLIDER', value)
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
